var map = {
	"./Capacity": [
		79906,
		9906
	],
	"./Capacity.json": [
		79906,
		9906
	],
	"./ComputationOperations": [
		46015,
		6015
	],
	"./ComputationOperations.json": [
		46015,
		6015
	],
	"./Length": [
		39962,
		9962
	],
	"./Length.json": [
		39962,
		9962
	],
	"./Lines": [
		32093,
		2093
	],
	"./Lines.json": [
		32093,
		2093
	],
	"./Money": [
		52822,
		2822
	],
	"./Money.json": [
		52822,
		2822
	],
	"./NumberNames": [
		95593,
		5593
	],
	"./NumberNames.json": [
		95593,
		5593
	],
	"./NumberSense": [
		54731,
		4731
	],
	"./NumberSense.json": [
		54731,
		4731
	],
	"./Numerals": [
		49837,
		9837
	],
	"./Numerals.json": [
		49837,
		9837
	],
	"./Patterns": [
		3365,
		3365
	],
	"./Patterns.json": [
		3365,
		3365
	],
	"./Pictographs": [
		81022,
		1022
	],
	"./Pictographs.json": [
		81022,
		1022
	],
	"./ShapesAndSolids": [
		13433,
		3433
	],
	"./ShapesAndSolids.json": [
		13433,
		3433
	],
	"./Temperature": [
		10568,
		568
	],
	"./Temperature.json": [
		10568,
		568
	],
	"./Time": [
		65435,
		5435
	],
	"./Time.json": [
		65435,
		5435
	],
	"./Weight": [
		16270,
		6270
	],
	"./Weight.json": [
		16270,
		6270
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77295;
module.exports = webpackAsyncContext;